import { storeToRefs } from 'pinia'
import { ref } from 'vue'

import { userDataApi, userDataModel } from '@/entities/user-data'
import { isErrorResponse } from '@/shared/api'
import { transliterateCarNumber } from '@/shared/lib/formatting'

import { addCar, deleteCar } from '../api'

export function useTransport() {
    const isLoading = ref(false)

    const store = userDataModel.useModel()
    const { setUserData } = store
    const { userData } = storeToRefs(store)

    async function deleteTransport(id: number) {
        isLoading.value = true
        const { data, response } = await deleteCar(id)
        isLoading.value = false

        if (!response?.ok || (data && isErrorResponse(data))) return false

        if (userData.value) {
            const newTransportList = userData.value.grn_list?.filter((item) => item.id !== id)

            setUserData({
                ...userData.value,
                grn_list: newTransportList ?? null,
            })
        }

        return true
    }

    async function addTransport(
        payload: Omit<userDataApi.Grn, 'id'>
    ): Promise<{ id?: number; mask_phone?: string; success: boolean }> {
        isLoading.value = true
        const { data, response } = await addCar({
            ...payload,
            grn: transliterateCarNumber(payload.grn),
        })
        isLoading.value = false

        if (!response?.ok || (data && isErrorResponse(data))) {
            return { success: false }
        }

        const newId = data?.car_id
        const maskPhone = data?.mask_phone

        if (maskPhone && !newId) {
            return {
                mask_phone: maskPhone,
                success: false,
            }
        }

        if (!newId) return { success: false }

        const newTransport = { grn: payload.grn, grn_country: payload.grn_country, id: newId }

        if (userData.value) {
            setUserData({
                ...userData.value,
                grn_list: [...(userData.value?.grn_list || []), newTransport],
            })
        }

        return {
            id: newId,
            success: true,
        }
    }

    return {
        addTransport,
        deleteTransport,
        isLoading,
    }
}
